module.exports = __webpack_public_path__ + "img/jiao.5dc47a40.svg";